import { useContext, useState } from "react";
import { Card, Tabs, Space, Typography, Button, Rate, Descriptions, Collapse } from "antd";
import { 
  useProductEntriesQuery,
  useSubmitProductEntryMutation 
} from "../../generated/graphql";
import { useParams } from "react-router-dom";
import { MutationResult } from "@apollo/client";
import { EntrySubmissionModal } from "../../components/entry-submission/EntrySubmissionModal";
import { EntryList } from "../../components/entry-list/EntryList";

import consumption_types from "../../local_data/consumption_types";
import product_types from "../../local_data/product_types";
import fragrance_types from "../../local_data/fragrance_types";
import terpene_types from "../../local_data/terpene_types";

const { Panel } = Collapse;
const { TabPane } = Tabs;
const { Title, Text } = Typography;
interface Props {
  setSelectedProduct: any
  setEntryModalVisible: any
  productData: any
  productDataLoading: any
}
const callback = () => {}
export const ProductList = (props: Props) => {
  const {setSelectedProduct, setEntryModalVisible, productData, productDataLoading} = props;
  const { id } = useParams<{ id: string }>();

  const terpeneTypeLookUp = (id: any) =>  terpene_types.find(x => x.terpene_type_id === id);
  const fragranceTypeLookUp = (id: any) =>  fragrance_types.find(x => x.fragrance_type_id === id);
  const productTypeLookUp = (id: any) =>  product_types.find(x => x.product_type_id === id);
  const userFeelingcategories = [
    "Sad/Happy",
    "Couchlock/Energetic",
    "Anxious/Mellow",
    "Unfocused/Focused",
    "High Pain/Low Pain",
  ];

  const formatDate = (date: Date) => {
    var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();
  
    return [date.getFullYear(),
            (mm>9 ? ' ' : '0') + mm,
            (dd>9 ? ' ' : '0') + dd
           ].join(' ');
  };
  

  return (
    <Collapse defaultActiveKey={['1']} onChange={callback}>
            
      {productDataLoading ? (
        <Title level={4}>Products are loading...</Title>
      ) : (
        productData?.product_entries.map(
          (product: any, index: any) => {
            const {
              batch_id,
              cbc,
              cbd,
              cbda,
              cbg,
              comments_enabled,
              created_at,
              delta8_thc,
              dispensary_id,
              fragrance_type_id,
              variety_name,
              user_rating_delta,
              user_rating_description_id,
              user_description,
              updated_at,
              track_trace_id,
              thcv,
              thca,
              thc,
              terpene_type_id,
              strain_id,
              product_type_id,
              product_entry_id,
              harvest_date,
            } = product;
            const terpeneTypeIds = terpene_type_id?.split(',');
            const fragranceTypeIds = fragrance_type_id?.split(',');
            const callback = (key: any) => {
              console.log(key);
            }
            return (
              <Panel header={`${variety_name} |  ${formatDate(new Date(created_at))}`} key={index+1}>
                <Tabs
                  defaultActiveKey="1"
                  tabPosition={"top"}
                  style={{ height: "auto" }}
                >
                  <TabPane key={1} tab={`Variety`} style={{ height: "auto" }}>
                    <Descriptions
                      bordered
                      column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                    >
                    <Descriptions.Item label="Product Type">
                      {productTypeLookUp(product_type_id)?.product_type_name_en}
                    </Descriptions.Item>
                    <Descriptions.Item label="Track and Trace ID">
                      {track_trace_id}
                    </Descriptions.Item>
                    <Descriptions.Item label="Batch Id">
                      {batch_id}
                    </Descriptions.Item>
                    <Descriptions.Item label="Harvest Date">
                      {harvest_date}
                    </Descriptions.Item>
                    <Descriptions.Item label="Farmer / Brand">
                      &nbsp;
                    </Descriptions.Item>
                    <Descriptions.Item label="Dispensary">
                      {dispensary_id}
                    </Descriptions.Item>
                    </Descriptions>
                  </TabPane>
                  <TabPane key={0} tab={`Terpenes`} style={{ height: "auto" }}>
                    <Descriptions
                      bordered
                      column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                    >
                      <Descriptions.Item label="Fragrance">
                      {fragranceTypeIds?.map((id:string) => {return fragranceTypeLookUp(id)?.fragrance_name_en + ', '})}
                      </Descriptions.Item>
                      <Descriptions.Item label="Terpenes">
                      {terpeneTypeIds?.map((id:string) => {return terpeneTypeLookUp(id)?.terpene_name_en})}
                      </Descriptions.Item>
                    </Descriptions>
                  </TabPane>
                  <TabPane key={2} tab={`Cannabinoid`}>
                    <Descriptions bordered
                      column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}>
                    <Descriptions.Item label="THC">
                      {thc}
                    </Descriptions.Item>
                    <Descriptions.Item label="THCA">
                      {thca}
                    </Descriptions.Item>
                    <Descriptions.Item label="THCV">
                      {thcv}
                    </Descriptions.Item>
                    <Descriptions.Item label="CBD">
                      {cbd}
                    </Descriptions.Item>
                    <Descriptions.Item label="CBDA">
                      {cbda}
                    </Descriptions.Item>
                    <Descriptions.Item label="CBG">
                      {cbg}
                    </Descriptions.Item>
                    <Descriptions.Item label="CBC">
                      {cbc}
                    </Descriptions.Item>
                    <Descriptions.Item label="Delt8THC">
                      {delta8_thc}
                    </Descriptions.Item>
                    </Descriptions>
                  </TabPane>
                </Tabs>
                <br/>
                <Space direction="vertical" align="center">
                  <Text>Log your cannabis consumption by hitting new entry below</Text>
                  <br/>
                  <Button
                    type="primary"
                    onClick={() => {
                      setSelectedProduct(product_entry_id);
                      setEntryModalVisible(true);
                    }}
                  >
                    Add Entry
                  </Button>
                  <br />
                </Space>
                  <EntryList productEntryId={product_entry_id} />
                  </Panel>
            );
          }
        )
      )}
      </Collapse>
  );
};
